export default __webpack_public_path__ + "static/fin-trade-profit-c80759e49d0a56bd432880950fffc424.png";